import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe, DatePipeConfig } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { SupportedLocale } from '@app/core/locale';

@Pipe({
    name: 'shortDate',
})
export class ShortDatePipe implements PipeTransform {
    private readonly datePipe: DatePipe;

    constructor(
        @Inject(LOCALE_ID) localId: SupportedLocale,
        @Inject(DATE_PIPE_DEFAULT_OPTIONS) defaultOptions: DatePipeConfig,
    ) {
        this.datePipe = new DatePipe(localId, defaultOptions?.timezone);
    }

    transform(value: Date | string | number | null | undefined): string | null {
        return this.datePipe.transform(value, 'shortDate');
    }
}
